import * as React from 'react'

import * as plume from '@ulule/owl-kit-components/next'

import * as money from '@owl-nest/money'
import * as env from '@owl-nest/config'

import { type InputProps } from './types'

export function StandaloneTipInput({
  symbol,
  onChange,
  selected,
  translations,
  value,
  error,
}: InputProps & {
  error?: string
}): React.ReactElement<InputProps> {
  const userConfig = env.useUserEnv()

  return (
    <plume.MoneyField
      data-testid="component:tip.standaloneinput"
      placeholder={translations?.placeholder}
      selected={selected}
      symbol={symbol}
      symbolPosition={money.getPosition(userConfig.lang)}
      value={value}
      onChange={(event) => {
        onChange?.(event.target.value)
      }}
      error={error}
    />
  )
}
